'use client'
import { useEffect, useState } from 'react'
import Link from 'next/link'
import { useAuth } from '@/context/AuthContext'
import TrendingDealCard from './TrendingDealCard'

export default function TrendingDealsSection() {
  const { accessToken } = useAuth()
  const [deals, setDeals] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function load() {
      try {
        const headers = {}
        if (accessToken) {
          headers['Authorization'] = `Bearer ${accessToken}`
        }
        const res = await fetch('/api/deals', { headers })
        const data = await res.json()
        const visible = (data.deals ?? []).filter(d => !d._locked).slice(0, 5)
        setDeals(visible)
      } catch (_) {}
      finally { setLoading(false) }
    }
    load()
  }, [accessToken])

  if (loading) return (
    <section className="py-10 sm:py-14">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-end justify-between mb-5">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-blue-600 mb-1">🔥 Trending now</p>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Top deals today</h2>
          </div>
          <Link href="/deals" className="text-sm font-semibold text-blue-600 hover:underline shrink-0">All deals →</Link>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="rounded-2xl bg-gray-100 animate-pulse aspect-[3/4]" />
          ))}
        </div>
      </div>
    </section>
  )

  if (deals.length === 0) return null

  return (
    <section className="py-10 sm:py-14">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-end justify-between mb-5">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-blue-600 mb-1">🔥 Trending now</p>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Top deals today</h2>
          </div>
          <Link href="/deals" className="text-sm font-semibold text-blue-600 hover:underline shrink-0">All deals →</Link>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {deals.map((deal) => (
            <TrendingDealCard key={deal.id} deal={deal} locked={false} />
          ))}
        </div>
      </div>
    </section>
  )
}
